export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0026.4dce43ba.webp";